import { API_ALLOWANCE_TYPE_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_ALLOWANCE_TYPES_CONFIGURABLES } from "../../utils/urls";

export const useAllowanceTypeConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "type_of_allowance",
          type: "text",
          label: "Allowance Type",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_ALLOWANCE_TYPES_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitAllowanceTypeConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_ALLOWANCE_TYPE_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_ALLOWANCE_TYPE_CONFIGURABLES,
    params: payload,
  };
}
